export default __webpack_public_path__ + "static/media/Angle-White.957f4858.svg";